import getPayload from 'ofs/utils/getPayload';

export function reverse(name, values) {
  const {urls} = getPayload();

  if (typeof urls[name] === 'undefined') {
    throw new Error(`No url called ${name}`);
  }

  let pattern = urls[name];
  return pattern.replace(/%\((.*?)\)s/g, (match, namedMatch) => {
    if (typeof values[namedMatch] === 'undefined') {
      throw new Error(`Url ${name} requires kwarg ${namedMatch}`);
    }
    return values[namedMatch];
  });
}



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/urls.js
 **/